import { defa } from 'defa-object';

/**
 * defa.views.ClaimTermsForm
 * A view for accepting DEFA subscription terms and conditions.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/claimTermsForm.jst.html'

const selectors = {
	inputAccept: '[data-input=terms-accept]',
};

const ClaimTermsForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		accept: selectors.inputAccept,
	},
	
	events: {
		'change @ui.accept': 'onChangeAccept',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the view is rendered.
	 * @void
	 */
	onRender: function () {
		this.createTermsHTML();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	createTermsHTML: function () {
		let country = this.options.customer.get( 'countryCode' );
		
		let index = _.findIndex( defa.vars.languages, function ( language ) {
			return language.languageCode.includes( country );
		} );
		
		let languageCode = 'en';
		if(index !== -1){
			languageCode = defa.vars.languages[ index ].languageCode.substr( 0, 2 );
		}
		// there are no french terms and conditions, so they get english ones.
		if ( 'fr' === languageCode ) {
			languageCode = 'en';
		}
		
		let url = '%s1assets/scripts/terms/terms-%s2.html'.replace( '%s1', defa.vars.base ).replace( '%s2', languageCode );
		
		$.get( url )
		 .done( function ( response ) {
			 $( '.scroll-frame' ).append( response );
		 } );
	},
	
	/**
	 * Validates the form by verifying the accept terms and conditions checkbox is checked.
	 * @void
	 */
	validate: function () {
		return this.ui.accept.is( ':checked' );
	},
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		this.trigger( 'claim:acceptTerms' );
	},
	
} );

export default ClaimTermsForm;
